export default defineNuxtPlugin(async () => {
  if (typeof Array.prototype.toSorted !== 'function') {
    await import('core-js/features/array/to-sorted');
  }
});